import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";
import App from "./App";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import UMCResult from "./components/common/UMCResult";
import ProtectedRoutes from "./components/auth/ProtectedRoutes";
import OxeAuth from "./components/auth/OxeAuth";
import Logout from "./components/auth/Logout";
import { EXPERT_CONFIG, LINKS, OXE_LOGIN, SIP_TRUNK, USERS_CONFIG, WHATS_NEW } from "./utils/Constants";
import "../src/styles/fonts/font.css"
import "./index.css";
import "../src/styles/layout.css"
import "../src/styles/users.css"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/unauthorized" element={<UMCResult status={401} title={"MSG_UNAUTHORIZED_ACCESS"} />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/umc-oxe" element={<OxeAuth />} />
        <Route element={<ProtectedRoutes />}>
          <Route path={`/${OXE_LOGIN}`} element={<App app={OXE_LOGIN}/>} />
          <Route path={`/${USERS_CONFIG}`} element={<App />} />
          <Route path={`/${SIP_TRUNK}`} element={<App />} />
          <Route path={`/${EXPERT_CONFIG}`} element={<App />} />
          <Route path={`/${WHATS_NEW}`} element={<App />} />
          <Route path={`/${LINKS}`} element={<App />} />
          <Route exact path="/" element={<Navigate to={`/${OXE_LOGIN}`} replace />} />
        </Route>
        <Route path="*" element={<UMCResult status={404} title={"MSG_PAGE_NOT_EXIST"} />} />
      </Routes>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
